import { createFileRoute } from '@tanstack/react-router';

import { WorkspaceAssessmentListScreen } from '@/features/assessments/components/workspace/AssessmentListScreen';
import { requirePermission } from '@/lib/guards';

export const Route = createFileRoute('/app/assessments/')({
  beforeLoad: () => {
    requirePermission('assessment:read');
  },
  component: ClinicalAssessmentListRoute,
  staticData: { crumb: 'Assessments' },
});

function ClinicalAssessmentListRoute() {
  return <WorkspaceAssessmentListScreen surface="clinical" />;
}
